import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const TypeOfServiceOptions: DropdownOptionType[] = [
  { value: 'AIR', display: 'AIR' },
  { value: 'SF', display: 'SF' },
  { value: 'PT', display: 'PT' },
];

export const ServiceTypeOptions: DropdownOptionType[] = [
  { value: 'Parcel', display: 'Parcel' },
  { value: 'Standard', display: 'Standard' },
  { value: 'Prime', display: 'Prime' },
  { value: 'Roadx', display: 'Roadx' },
  { value: 'Tecex', display: 'Tecex' },
  { value: 'Vtexp', display: 'Vtexp' },
  { value: 'Smexp', display: 'Smexp' },
];

export const DocTypeOptions: DropdownOptionType[] = [
  { value: 'D', display: 'Dox' },
  { value: 'N', display: 'Non Dox' },
];

export const trackonInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  ServiceType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Service Type is required'),
  TypeOfService: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Type of Service is required'),
  DocType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Doc Type is required'),
});

export interface trackonInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  ServiceType: string;
  TypeOfService: string;
  DocType: string;
  PickupCustCode: string;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: trackonInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'trackon';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
